var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.listing.sold === false)?_c('div',{staticClass:"btn btn-primary action--button",class:{ 'btn-block': _vm.full, running: _vm.loading },on:{"click":_vm.open}},[_vm._v(" Reservasi Properti ")]):_c('div',{staticClass:"btn bg-grey"},[_vm._v("Properti Terjual")])])
}
var staticRenderFns = []

export { render, staticRenderFns }